import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import * as refValSheetActions from './reference-value-sheet.actions';
import { ReferenceValueSheet, RefValSheetModuleState } from '../models/reference-value-sheet.model';

function selectIdNumber(c: ReferenceValueSheet): number {
  return c.id;
}
export const adapter: EntityAdapter<ReferenceValueSheet> = createEntityAdapter<ReferenceValueSheet>(
  {
    selectId: selectIdNumber,
  },
);

export const initialState = <RefValSheetModuleState>{
  refValSheets: adapter.getInitialState([]),
  isLoaded: false,
  columns: [],
};
const ReferenceValueSheetReducer = createReducer(
  initialState,
  on(refValSheetActions.clearRefValSheetState, (state) => ({
    ...state,
    isLoaded: false,
    refValSheets: adapter.removeAll(state.refValSheets),
  })),
  on(refValSheetActions.loadRefValSheetsSuccess, (state, { refValSheets }) => ({
    ...state,
    isLoaded: true,
    refValSheets: adapter.setAll(refValSheets, state.refValSheets),
  })),
  on(refValSheetActions.loadStandardRefValSheetsByCountrySuccess, (state, { refValSheets }) => ({
    ...state,
    isLoaded: true,
    refValSheets: adapter.setAll(refValSheets, state.refValSheets),
  })),
  on(refValSheetActions.upsertRefValSheetSuccess, (state, { refValSheet }) =>
    // when RVS was copied to another country, it must not be added to current state
    state.selectedCountry === refValSheet.country
      ? {
          ...state,
          refValSheets: adapter.upsertOne(refValSheet, state.refValSheets),
        }
      : state,
  ),
  on(refValSheetActions.deleteRefValSheetSuccess, (state, { refValSheetId }) => ({
    ...state,
    refValSheets: adapter.removeOne(refValSheetId, state.refValSheets),
  })),
  on(refValSheetActions.loadSelectedCountrySuccess, (state, { id }) => ({
    ...state,
    selectedCountry: id,
  })),
  on(refValSheetActions.setSelectedCountrySuccess, (state, { id, refValSheets }) => ({
    ...state,
    selectedCountry: id,
    refValSheets: adapter.setAll(refValSheets, state.refValSheets),
  })),
  on(refValSheetActions.setColumnSettings, (state, { value }) => ({
    ...state,
    columns: value,
    isLoaded: true,
  })),
  on(refValSheetActions.setBaseRefValSheetSuccess, (state, { refValSheet }) => ({
    ...state,
    baseRefValSheet: refValSheet,
  })),
);

export function reducer(state: RefValSheetModuleState | undefined, action: Action) {
  return ReferenceValueSheetReducer(state, action);
}
